// Core material math. 1 bag = 50 kg. rate = approx count per 50 kg.
export function fromWeight(weightKg, rate) {
  const w = Number(weightKg) || 0;
  return { weight: w, bags: w / 50, pieces: rate ? (w * rate) / 50 : 0 };
}
export function fromBags(bags, rate) {
  const b = Number(bags) || 0;
  const w = b * 50;
  return { weight: w, bags: b, pieces: rate ? (w * rate) / 50 : 0 };
}
export function fromPieces(pieces, rate) {
  const p = Number(pieces) || 0;
  const w = rate ? (p * 50) / rate : 0;
  return { weight: w, bags: w / 50, pieces: p };
}
export function computeTrio(field, value, rate) {
  if (field === "bags") return fromBags(value, rate);
  if (field === "pieces") return fromPieces(value, rate);
  return fromWeight(value, rate);
}
// weight per piece in grams from a per-50kg rate
export function gramsPerPiece(rate) {
  return rate ? 50000 / rate : 0;
}
// effective rate (count per 50kg) from grams-per-piece
export function rateFromGrams(g) {
  return g ? 50000 / Number(g) : 0;
}
// washer rate (count per 50kg) from the 3 input modes
export function washerRate(mode, value) {
  const v = Number(value) || 0;
  if (v <= 0) return 0;
  if (mode === "pcsbag") return v; // pieces per 50 kg bag
  if (mode === "wtpc") return 50000 / v; // grams per piece
  if (mode === "kg100") return 5000 / v; // kg per 100 pieces
  return 0;
}
